<template>
  <div>
    <b-row v-for="(n, index) in multPmts" :key="index" class="py-1">
      <b-col sm="6" v-if="index === multPmts.length - 1">
        <form-read-group-label-input isMandatory
          type="number"
          :inputLabel="$t('common.amnt')"
          :placeholderValue="'Amount ('+ ccy + ')'"
          :inputValue="parseFloat(parseFloat(n.amount).toFixed(2)).toString()"> <!--'common.amnt'-->
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" v-else>
        <form-write-group-label-input v-model="n.amount" isMandatory
          inputType="number"
          :inputLabel="$t('common.amnt')"
          :placeholderValue="$t('common.amnt') + ' ('+ ccy + ')'">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" v-if="index === multPmts.length - 1">
        <form-write-group-label-input v-model="n.date" isMandatory disabled
          inputType="date" disablePastDates :disableFromDate="execDate"
          :id="'negotiationDateInput' + index"
          :inputLabel="$t('common.date_label')" :placeholderValue="$t('common.slct_date')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" v-else>
        <form-write-group-label-input v-model="n.date" isMandatory
          inputType="date" disablePastDates :disableFromDate="execDate"
          :id="'negotiationDateInput' + index"
          :inputLabel="$t('common.date_label')" :placeholderValue="$t('common.slct_date')">
        </form-write-group-label-input>
      </b-col>
      <!--
      <b-col xs="6">
        <input class="form-control" name="amount" :placeholder="'Amount ('+ ccy + ')'" style='display:inline-block'
               type="number" v-model="n.amount" v-bind="{readonly : index === multPmts.length - 1}">
        </input>
      </b-col>
      <b-col xs="6">
        <input class="form-control" type="date" v-bind:id="'negotiationDateInput' + index"
               placeholder="Select a date" v-model="n.date">
      </b-col>-->
    </b-row>
    <b-row class="form-group row justify-content-end">
      <b-col cols="8">
        <div class="text-right font-weight-bold fs-12px w-100">
          {{ $t('regles_metier.rqstng') }} <font :color="sumColor">{{sum + ccy}}</font> {{ $t('common.of_label') }}
          <!--En mettant 0 en bas par défaut tant que l'amount n'est pas rempli -->
          <font color="#12bcf1">{{amount==''?'0' + ccy:amount +ccy}}</font>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'EcheancierForm',
  props: ['numPay', 'min', 'amount', 'ccy', 'value', 'deposit', 'execDate'], // value = multPmts (v-model)
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  computed: {
    multPmts: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    sumColor () {
      if (Number(this.sum) === Number(this.amount)) {
        return '#12bcf1'
      } else {
        return 'red'
      }
    },
    sum () {
      let sum = 0
      for (let i = 0; i < this.multPmts.length; i++) {
        sum += (this.multPmts[i].amount === '' || this.multPmts[i].amount == null) ? 0
        : parseFloat(parseFloat((typeof this.multPmts[i].amount === 'number'
                    ? this.multPmts[i].amount.toString()
                    : this.multPmts[i].amount).replace(/\s/g, '')).toFixed(2))
      }
      sum += (this.deposit == null || this.deposit === '') ? 0 : parseFloat(this.deposit) // On ajoute le deposit, correspondant a l'echeance 0
      return parseFloat(sum.toFixed(2))
    }
  },
  watch: {
    numPay (num) {
      if (num >= this.min) {
        let multi = this.defineArray(num)
        multi = this.adjustLastAmount(multi)
        this.updateInstallments(multi)
      }
    },
    deposit () {
      this.updateInstallments(this.adjustLastAmount(this.multPmts))
    },
    amount () {
      this.updateInstallments(this.adjustLastAmount(this.multPmts))
    },
    value: {
      handler () {
        this.updateInstallments(this.adjustLastAmount(this.multPmts))
      },
      deep: true
    }
  },
  created () {
    if (this.multPmts.length === 0) {
      this.updateInstallments(this.defineArray(this.numPay))
    }
  },
  methods: {
    updateInstallments (multPmts) {
      this.$emit('input', multPmts)
    },
    defineArray (n) {
      let multPmts = []
      for (let i = 0; i < n - 1; i++) {
        multPmts.push({
          date: moment().format('YYYY-MM-DD'),
          amount: ''
        })
      }
      multPmts.push({
        date: moment(this.execDate).format('YYYY-MM-DD'),
        amount: ''
      })
      return multPmts
    },
    adjustLastAmount (multi) {
      if (this.numPay > 0) {
        let deposit = (!this.deposit) ? 0 : this.deposit
        let amount = (!this.amount) ? 0 : this.amount
        let sum = 0
        let multPmts = multi
        for (let i = 0; i < multPmts.length - 1; i++) {
          if (multPmts[i].amount !== '' && multPmts[i].amount > 0) {
            sum += Number(multPmts[i].amount)
          }
        }

        let lastAmount = amount - deposit - sum
        if (lastAmount < 0) {
          lastAmount = 0
        }
        multPmts[multPmts.length - 1].amount = lastAmount
        return multPmts
      }
      return this.multPmts
    }
  }
}
</script>
